import { ChainId, GameAddresses, addressesByNetwork } from "@looksrare/config";

const supportedPtbChains = [ChainId.MAINNET, ChainId.SEPOLIA, ChainId.ARB_MAINNET, ChainId.ARB_SEPOLIA];

/**
 * A mapping of address PTB needs for the FE (Ethereum & Arbitrum)
 */
export const gameAddresses = supportedPtbChains.reduce<Record<ChainId, GameAddresses>>((accum, chain) => {
  return {
    ...accum,
    [chain]: {
      ETH: addressesByNetwork[chain].ETH,
      BOOST: "0x", // Not supported on FE
      USDB: "0x", // Not supported on FE
      YIELD: "0x", // Not supported on FE
      YES: "0x", // Not supported on FE
      ORBIT: "0x", // Not supported on FE
      JUICE: "0x", // Not supported on FE
      PAC: "0x", // Not supported on FE
      LOOKS: addressesByNetwork[chain].LOOKS,
      USDC: addressesByNetwork[chain].USDC,
      USDT: addressesByNetwork[chain].USDT,
      WETH: addressesByNetwork[chain].WETH,
      PTB: addressesByNetwork[chain].POKE_THE_BEAR,
      FLIPPER: addressesByNetwork[chain].FLIPPER,
      PTB_TRANSFER_MANAGER: addressesByNetwork[chain].TRANSFER_MANAGER,
      YOLO_PLAY: "0x", // Not supported?
      YOLO_V2: addressesByNetwork[chain].YOLO_V2,
      YOLO_V1_LIMITED: "0x", // Not supported on FE
      YOLO_TRANSFER_MANAGER: addressesByNetwork[chain].TRANSFER_MANAGER,
      MOON_OR_DOOM_NATIVE_TOKEN_ETH: addressesByNetwork[chain].MOON_OR_DOOM_NATIVE_TOKEN_ETH,
      MOON_OR_DOOM_NATIVE_TOKEN_BTC: addressesByNetwork[chain].MOON_OR_DOOM_NATIVE_TOKEN_BTC,
      QUANTUM: "0x", // Not supported on FE
      GAME_CONFIG_MANAGER: "0x", // Not supported on FE
    },
  };
}, {} as Record<ChainId, GameAddresses>);
